import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "progress-container" }

import { computed } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseProgressBar',
  props: {
  maxAmount: {
    type: Number,
    required: true,
  },
  currentAmount: {
    type: Number,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const progressPercentage = computed(() => {
  return Math.min(100, (props.currentAmount / props.maxAmount) * 100);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "progress-bar",
      style: _normalizeStyle({ width: progressPercentage.value + '%' })
    }, null, 4)
  ]))
}
}

})